module.exports = __webpack_public_path__ + "assets/img/8.fc42057d.gif";